import { IconDefinition } from '@fortawesome/pro-light-svg-icons';

export enum SearchType {
  ALL = 'ALL',
  LABORATORIAL_EXAM = 'LABORATORIAL_EXAM',
  ONLINE_CONSULTATION = 'ONLINE_CONSULTATION',
  PRESENTIAL_CONSULTATION = 'PRESENTIAL_CONSULTATION',
  DOCTOR = 'DOCTOR',
  VACCINE = 'VACCINE',
  IMAGE_EXAM = 'IMAGE_EXAM',
  CLINIC = 'CLINIC',
  EMERGENCY = 'EMERGENCY',
  SURGERY = 'SURGERY',
  BRANCH_LABORATORY = 'BRANCH_LABORATORY',
}

export type MostSearchedResultType = {
  title?: string;
  type: SearchType;
  iconName?: IconDefinition;
  procedures: MostSearchedResult[];
};

export type MostSearchedResult = {
  id: string;
  name?: string | null;
  code: string;
  description?: string | null;
  procedureType?: string;
  displayName: string;
  slug?: string | null;
  alias?: string | null;
  keywords?: string[] | null;
  specialties?: ProfessionalSpecialty[];
  availableForTelehealth?: boolean;
  type: SearchType;
  minPrice?: number;
};

export type ProfessionalSpecialty = {
  id: string;
  name: string;
  description: string | null;
  specialistQualificationRecord?: string;
};
